import axios from "axios";
import { getExperienceApi } from '../_constants/api.constant'
import {  getSelfToken } from '../../_helpers/auth/secureToken'
export async function addExperienceService(postData) {
    const response = await axios.post(
        getExperienceApi.POST,
        postData,
        {
            headers: {
                Authorization: 'Token ' + getSelfToken(),
            },
        }
    ).then(function (response) {
       // window.location.reload();

        return response;
    }).catch(function (error) {
        // handle error
        console.log(error);
        console.log(error.response);
        return error.response;
    });
    return response;
}